import type { CandidateExperienceApi } from '@/modules/candidate-detail/queries/types';

/** Missing or unparseable dates sort after every dated role. */
const toTime = (value: string | null) => {
  const time = value ? Date.parse(value) : Number.NaN;
  return Number.isNaN(time) ? Number.NEGATIVE_INFINITY : time;
};

const endTime = (role: CandidateExperienceApi) =>
  role.endDate ? toTime(role.endDate) : Number.POSITIVE_INFINITY;

const descending = (a: number, b: number) => (a === b ? 0 : a > b ? -1 : 1);

/**
 * Newest role first: current roles (no end date) lead, then by end date,
 * then by start date, both descending.
 */
export function sortRolesNewestFirst(
  roles: CandidateExperienceApi[],
): CandidateExperienceApi[] {
  return [...roles].sort(
    (a, b) =>
      descending(endTime(a), endTime(b)) ||
      descending(toTime(a.startDate), toTime(b.startDate)),
  );
}
